const mapping = {
  Superadmin: {
    "dance-styles": {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    patterns: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    variations: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    videos: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    routines: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
  },
  Admin: {
    "dance-styles": {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    patterns: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    variations: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    videos: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    routines: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
  },
  Bronze: {
    "dance-styles": {
      list: true,
    },
    patterns: {
      list: true,
    },
    variations: {
      list: true,
    },
    videos: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
    routines: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
  },
  default: {
    "dance-styles": {
      list: true,
    },
    patterns: {
      list: true,
    },
    variations: {
      list: true,
    },
    routines: {
      create: true,
      delete: true,
      list: true,
      update: true,
    },
  },
};
export const hasAccess = (
  groups: string[],
  resource: string,
  action: string
) => {
  if (!groups) return false;
  const groupList = Object.keys(mapping);
  const group = groupList.find((group) => groups.includes(group)) || "default";
  const resourceMapping = mapping[group as keyof typeof mapping];
  if (!resourceMapping) return false;
  const actionMapping =
    resourceMapping[resource as keyof typeof resourceMapping];
  if (!actionMapping) return false;
  return actionMapping[action as keyof typeof actionMapping];
};
